import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { t } from 'i18next';

export default function ExerciseRatioPie({ totalExercises, totalSkipped, ratio }) {
    return (
        <Card>
            <CardContent sx={{ backgroundColor: '#f9f9f9' }}>
                <Typography variant="h5" fontWeight={700} gutterBottom>
                    {t('exerciseStats.completedVsSkipped')}
                </Typography>
                <Box
                    sx={{
                        height: 3,
                        width: 195,
                        backgroundColor: '#1976d2',
                        borderRadius: 2,
                        mb: 2
                    }}
                />
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={[
                                {
                                    name: t('exerciseStats.completed'),
                                    value: totalExercises
                                },
                                { name: t('exerciseStats.skipped'), value: totalSkipped }
                            ]}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={70}
                            paddingAngle={3}
                            dataKey="value"
                            label
                        >
                            <Cell fill="#1976d2" />
                            <Cell fill="#7fb4e8" />
                        </Pie>
                        <text
                            x="50%"
                            y="43%"
                            textAnchor="middle"
                            fontSize="20"
                            fontWeight="bold"
                            fill="#1976d2"
                        >
                            {ratio}
                        </text>
                        <text
                            x="50%"
                            y="50%"
                            textAnchor="middle"
                            fontSize="14"
                            fontWeight="bold"
                        >
                            {t('exerciseStats.completed')}
                        </text>
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
}
